<template>
<div v-if="isShow()" id="seo">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">SEO</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="mb-2">
          <label class="form-label">Title</label>
          <div class="d-flex align-items-center gap-2">
            <input v-model="fields.title" type="text" class="form-control" placeholder="Title" @change="changeTitle" :class="{'is-invalid': v$.title.$invalid && v$.title.$dirty}">
            <div class="invalid-feedback" v-for="error of v$.title.$silentErrors" :key="error.$uid">
              {{ error.$message }}
            </div>
          </div>
        </div>

        <div class="mb-2">
          <label class="form-label">Description</label>
          <div class="d-flex align-items-center gap-2">
            <textarea v-model="fields.description" rows="6" class="form-control" placeholder="Description" @change="changeDescription" :class="{'is-invalid': v$.description.$invalid && v$.description.$dirty}"></textarea>
            <div class="invalid-feedback" v-for="error of v$.description.$silentErrors" :key="error.$uid">
              {{ error.$message }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import {useVuelidate} from "@vuelidate/core"

export default defineComponent({
  name: "SEO",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)

    let $externalResults = reactive({})

    const fields = reactive({
      title: "",
      description: "",
    })

    const rules = {
      title: {},
      description: {},
    }

    const v$ = useVuelidate(rules, fields, {$externalResults})

    function validate(fn) {
      v$.value.$clearExternalResults()
      return v$.value.$validate().then((resp) => {
        if (resp === true) {
          fn()
        }
      })
    }

    watch(() => props.payload, (val) => {
      updateFields(val)
    }, {
      immediate: true,
    })

    onMounted(async () => {
      markUnshow()
      markShow()
    })

    function updateFields(query) {
      fields.title = query.title
      fields.description = query.description
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function changeTitle() {
      validate(() => {
        pushEvent(fields.title, fields.description)
      })
    }

    function changeDescription() {
      validate(() => {
        pushEvent(fields.title, fields.description)
      })
    }

    function pushEvent(title, description) {
      emit("onChange", {
        title: title,
        description: description,
      })
    }

    return {
      isShow,
      fields,
      changeTitle,
      changeDescription,
      v$,
    }
  }
})
</script>

<style src="./css/style.css"></style>
